var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.801,
    height: 17.75,
    viewBox: "0 0 19.801 17.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-chat-5582868",
    d: "M121.79,60.375H108a3.012,3.012,0,0,0-3.005,3.006v9.186a3,3,0,0,0,2.85,3v.785a1.787,1.787,0,0,0,1.768,1.775,1.8,1.8,0,0,0,1.1-.382l1.011-.8a6.341,6.341,0,0,1,3.946-1.372h6.124a3.012,3.012,0,0,0,3.006-3.006V63.381a3.012,3.012,0,0,0-3.006-3.006Zm-3.359,9.851H111.36a.707.707,0,1,1,0-1.414h7.072a.707.707,0,0,1,0,1.414Zm0-3.09H111.36a.707.707,0,1,1,0-1.414h7.072a.707.707,0,1,1,0,1.414Z",
    transform: "translate(-104.995 -60.375)",
    fill: "#ff6036"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.71c94f1a2d731fe4c4af57dd5de22200.svg";
export { ForwardRef as ReactComponent };